(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-buy-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var cards = root.querySelectorAll('.pz-bb__bundle');
      if (!cards.length) return;
      var setInput = root.querySelector('.pz-bb__set-input');

      function select(card) {
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          var on = c === card;
          c.classList.toggle('is-selected', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        }
        if (setInput) {
          setInput.value = card.getAttribute('data-label') || '';
        }
      }

      root.addEventListener('click', function (e) {
        var card = e.target && e.target.closest ? e.target.closest('.pz-bb__bundle') : null;
        if (!card || !root.contains(card)) return;
        select(card);
      });
    }

    var roots = document.querySelectorAll('.pz-bb');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(section) {
      var pills = section.querySelectorAll('[data-pz-faq-pill]');
      var items = section.querySelectorAll('.pz-faq__item');
      var empty = section.querySelector('[data-pz-faq-empty]');
      if (!pills.length || !items.length) return;

      function apply(category) {
        var visibleCount = 0;
        for (var i = 0; i < items.length; i++) {
          var match = items[i].getAttribute('data-category') === category;
          if (match) {
            items[i].hidden = false;
            visibleCount++;
          } else {
            items[i].hidden = true;
          }
        }
        if (empty) {
          empty.hidden = visibleCount !== 0;
        }
      }

      section.addEventListener('click', function (e) {
        var pill = e.target && e.target.closest ? e.target.closest('[data-pz-faq-pill]') : null;
        if (!pill || !section.contains(pill)) return;

        for (var i = 0; i < pills.length; i++) {
          var active = pills[i] === pill;
          pills[i].classList.toggle('is-active', active);
          pills[i].setAttribute('aria-pressed', active ? 'true' : 'false');
        }
        apply(pill.getAttribute('data-pz-faq-pill'));
      });

      // Initial state: first pill's category.
      var first = pills[0];
      apply(first.getAttribute('data-pz-faq-pill'));
    }

    function initAll() {
      var sections = document.querySelectorAll('.pz-faq');
      for (var s = 0; s < sections.length; s++) {
        initFaq(sections[s]);
      }
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-feature-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function play(media) {
      if (media.classList.contains('is-playing')) return;
      var type = media.getAttribute('data-fs-type');
      if (type === 'shopify') {
        var v = media.querySelector('video');
        if (v) {
          media.classList.add('is-playing');
          v.setAttribute('controls', '');
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
      } else if (type === 'youtube' || type === 'vimeo') {
        var tpl = media.querySelector('template.pz-fs__embed');
        if (tpl && tpl.content) {
          media.appendChild(tpl.content.cloneNode(true));
          media.classList.add('is-playing');
        }
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button.pz-fs__play') : null;
      if (!btn) return;
      var media = btn.closest('.pz-fs__media-inner');
      if (media) play(media);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-product-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Thumbnail swap (product-info gallery) */
    document.addEventListener('click', function (e) {
      var thumb = e.target && e.target.closest ? e.target.closest('.pz-pi__thumb') : null;
      if (!thumb || thumb.classList.contains('pz-pi__thumb--ph')) return;
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      var section = thumb.closest('.pz-pi');
      if (!section) return;
      var main = section.querySelector('.pz-pi__main-img');
      if (main) {
        main.removeAttribute('srcset');
        main.setAttribute('src', full);
      }
      var thumbs = section.querySelectorAll('.pz-pi__thumb');
      for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.remove('is-active');
      thumb.classList.add('is-active');
    });

    /* Bundle selection (buy box) */
    function initBundles(root) {
      var cards = root.querySelectorAll('.pz-bb__bundle');
      if (!cards.length) return;
      var setInput = root.querySelector('.pz-bb__set-input');

      function select(card) {
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          var on = c === card;
          c.classList.toggle('is-selected', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        }
        if (setInput) {
          setInput.value = card.getAttribute('data-label') || '';
        }
      }

      root.addEventListener('click', function (e) {
        var card = e.target && e.target.closest ? e.target.closest('.pz-bb__bundle') : null;
        if (!card || !root.contains(card)) return;
        select(card);
      });
    }

    /* Variant selection (colour swatches -> real variant) */
    function initVariants(root) {
      var picker = root.querySelector('[data-pz-variant-picker]');
      var dataEl = root.querySelector('.pz-pi__variant-data');
      if (!picker || !dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var swatches = picker.querySelectorAll('[data-pz-swatch]');
      var currentEl = picker.querySelector('.pz-pi__swatch-current');
      var priceEl = root.querySelector('.pz-pi__price');
      var compareWrap = root.querySelector('.pz-pi__compare');
      var compareVal = root.querySelector('.pz-pi__compare-val');
      var badgeEl = root.querySelector('.pz-pi__badge');
      var idInput = root.querySelector('.pz-bb__id-input');
      var atc = root.querySelector('button.pz-bb__atc[type="submit"]');
      var atcText = atc ? atc.querySelector('.pz-bb__atc-text') : null;
      var atcArrow = atc ? atc.querySelector('.pz-bb__atc-arrow') : null;
      var mainImg = root.querySelector('.pz-pi__main-img');

      function findVariant(color) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].color === color) return variants[i];
        }
        return null;
      }

      function select(color) {
        var v = findVariant(color);
        if (!v) return;

        for (var i = 0; i < swatches.length; i++) {
          var on = swatches[i].getAttribute('data-pz-swatch') === color;
          swatches[i].classList.toggle('is-active', on);
          swatches[i].setAttribute('aria-checked', on ? 'true' : 'false');
        }

        if (currentEl) currentEl.textContent = color;
        if (priceEl) priceEl.textContent = v.price;
        if (idInput) idInput.value = v.id;

        if (compareWrap) {
          if (v.onSale) {
            compareWrap.hidden = false;
            if (compareVal) compareVal.textContent = v.compare;
          } else {
            compareWrap.hidden = true;
          }
        }

        if (badgeEl) {
          if (v.onSale) {
            badgeEl.hidden = false;
            var lbl = badgeEl.getAttribute('data-badge-label') || '';
            badgeEl.textContent = (v.discount + ' ' + lbl).trim();
          } else {
            badgeEl.hidden = true;
          }
        }

        if (atc) {
          atc.disabled = !v.available;
          if (atcText) atcText.textContent = v.available
            ? (atc.getAttribute('data-atc-label') || atcText.textContent)
            : (atc.getAttribute('data-soldout-label') || atcText.textContent);
          if (atcArrow) atcArrow.hidden = !v.available;
        }

        if (mainImg && v.img) {
          mainImg.removeAttribute('srcset');
          mainImg.setAttribute('src', v.img);
        }

        if (v.url && window.history && window.history.replaceState) {
          try { window.history.replaceState({}, '', v.url); } catch (e) {}
        }
      }

      picker.addEventListener('click', function (e) {
        var sw = e.target && e.target.closest ? e.target.closest('[data-pz-swatch]') : null;
        if (!sw || !picker.contains(sw)) return;
        select(sw.getAttribute('data-pz-swatch'));
      });
    }

    var roots = document.querySelectorAll('.pz-pi');
    for (var i = 0; i < roots.length; i++) {
      initBundles(roots[i]);
      initVariants(roots[i]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      var tabs = root.querySelectorAll('.rvx-rev-tab');
      var sortSelect = root.querySelector('.rvx-rev-sort');
      var panel = root.querySelector('.rvx-rev-panel');
      var pagination = root.querySelector('.rvx-rev-pagination');
      var cardEls = Array.prototype.slice.call(root.querySelectorAll('.rvx-rev-card'));
      if (!cardEls.length) return;

      function norm(v) { return (v || '').trim().toLowerCase(); }

      var perPage = parseInt(panel && panel.getAttribute('data-per-page'), 10);
      if (!perPage || perPage < 1) perPage = 5;

      var state = { filter: '', sort: 'recent', page: 1 };

      function getFiltered() {
        var showAll = !state.filter || state.filter.indexOf('all') === 0;
        return cardEls.filter(function (card) {
          var cat = norm(card.getAttribute('data-category'));
          return showAll || !cat || cat === state.filter;
        });
      }

      function getSorted(list) {
        if (state.sort !== 'rating') return list;
        return list.slice().sort(function (a, b) {
          var sa = parseInt(a.getAttribute('data-stars'), 10) || 0;
          var sb = parseInt(b.getAttribute('data-stars'), 10) || 0;
          return sb - sa;
        });
      }

      function buildPagination(totalPages) {
        if (!pagination) return;
        pagination.innerHTML = '';
        if (totalPages <= 1) return;

        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'rvx-rev-page-btn';
        prev.textContent = '\u2039';
        prev.disabled = state.page <= 1;
        prev.setAttribute('data-page', state.page - 1);
        pagination.appendChild(prev);

        for (var i = 1; i <= totalPages; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rvx-rev-page-btn' + (i === state.page ? ' is-active' : '');
          btn.textContent = i;
          btn.setAttribute('data-page', i);
          pagination.appendChild(btn);
        }

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'rvx-rev-page-btn';
        next.textContent = '\u203a';
        next.disabled = state.page >= totalPages;
        next.setAttribute('data-page', state.page + 1);
        pagination.appendChild(next);
      }

      function render() {
        var list = getSorted(getFiltered());
        var totalPages = Math.max(1, Math.ceil(list.length / perPage));
        if (state.page > totalPages) state.page = totalPages;
        if (state.page < 1) state.page = 1;

        var start = (state.page - 1) * perPage;
        var visible = list.slice(start, start + perPage);

        cardEls.forEach(function (card) { card.hidden = true; });
        visible.forEach(function (card) { card.hidden = false; });

        buildPagination(totalPages);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          state.filter = norm(tab.getAttribute('data-filter'));
          state.page = 1;
          render();
        });
      });

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          state.sort = sortSelect.value;
          state.page = 1;
          render();
        });
      }

      if (pagination) {
        pagination.addEventListener('click', function (e) {
          var btn = e.target.closest ? e.target.closest('.rvx-rev-page-btn') : null;
          if (!btn || btn.disabled) return;
          var page = parseInt(btn.getAttribute('data-page'), 10);
          if (!page) return;
          state.page = page;
          render();
        });
      }

      render();
    }
    function initAll(container) {
      (container || document).querySelectorAll('.rvx-reviews').forEach(initReviews);
    }
    initAll();
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-usecase-alltag"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function play(media) {
      if (media.classList.contains('is-playing')) return;
      var type = media.getAttribute('data-al-type');
      if (type === 'shopify') {
        var v = media.querySelector('video');
        if (v) {
          media.classList.add('is-playing');
          v.setAttribute('controls', '');
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
      } else if (type === 'youtube' || type === 'vimeo') {
        var tpl = media.querySelector('template.pz-al__embed');
        if (tpl && tpl.content) {
          media.appendChild(tpl.content.cloneNode(true));
          media.classList.add('is-playing');
        }
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button.pz-al__play') : null;
      if (!btn) return;
      var media = btn.closest('.pz-al__media');
      if (media) play(media);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-usecase-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function play(media) {
      if (media.classList.contains('is-playing')) return;
      var type = media.getAttribute('data-uv-type');
      if (type === 'shopify') {
        var v = media.querySelector('video');
        if (v) {
          media.classList.add('is-playing');
          v.setAttribute('controls', '');
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
      } else if (type === 'youtube' || type === 'vimeo') {
        var tpl = media.querySelector('template.pz-uv__embed');
        if (tpl && tpl.content) {
          media.appendChild(tpl.content.cloneNode(true));
          media.classList.add('is-playing');
        }
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button.pz-uv__play') : null;
      if (!btn) return;
      var media = btn.closest('.pz-uv__media');
      if (media) play(media);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-video-quickhits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function play(media) {
      if (media.classList.contains('is-playing')) return;
      var type = media.getAttribute('data-vq-type');
      if (type === 'shopify') {
        var v = media.querySelector('video');
        if (v) {
          media.classList.add('is-playing');
          v.setAttribute('controls', '');
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
      } else if (type === 'youtube' || type === 'vimeo') {
        var tpl = media.querySelector('template.pz-vq__embed');
        if (tpl && tpl.content) {
          media.appendChild(tpl.content.cloneNode(true));
          media.classList.add('is-playing');
        }
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button.pz-vq__play') : null;
      if (!btn) return;
      var media = btn.closest('.pz-vq__media');
      if (media) play(media);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panzwerk-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function play(media) {
      if (media.classList.contains('is-playing')) return;
      var type = media.getAttribute('data-vt-type');
      if (type === 'shopify') {
        var v = media.querySelector('video');
        if (v) {
          media.classList.add('is-playing');
          v.setAttribute('controls', '');
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
      } else if (type === 'youtube' || type === 'vimeo') {
        var tpl = media.querySelector('template.pz-vt__embed');
        if (tpl && tpl.content) {
          media.appendChild(tpl.content.cloneNode(true));
          media.classList.add('is-playing');
        }
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button.pz-vt__play') : null;
      if (!btn) return;
      var media = btn.closest('.pz-vt__media');
      if (media) play(media);
    });

    function initCarousels() {
      var sections = document.querySelectorAll('.pz-vt--carousel');
      for (var s = 0; s < sections.length; s++) {
        (function (section) {
          var grid = section.querySelector('.pz-vt__grid');
          var dots = section.querySelectorAll('.pz-vt__dot');
          if (!grid || !dots.length) return;

          function update() {
            var cards = grid.querySelectorAll('.pz-vt__card');
            if (!cards.length) return;
            var base = grid.getBoundingClientRect().left;
            var best = 0;
            var bestDist = Infinity;
            for (var i = 0; i < cards.length; i++) {
              var dist = Math.abs(cards[i].getBoundingClientRect().left - base);
              if (dist < bestDist) {
                bestDist = dist;
                best = i;
              }
            }
            for (var j = 0; j < dots.length; j++) {
              if (j === best) {
                dots[j].classList.add('is-active');
              } else {
                dots[j].classList.remove('is-active');
              }
            }
          }

          var ticking = false;
          grid.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
              update();
              ticking = false;
            });
          }, { passive: true });

          for (var k = 0; k < dots.length; k++) {
            (function (idx) {
              dots[idx].addEventListener('click', function () {
                var cards = grid.querySelectorAll('.pz-vt__card');
                if (cards[idx]) {
                  cards[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
                }
              });
            })(k);
          }

          update();
        })(sections[s]);
      }
    }

    if (document.readyState !== 'loading') {
      initCarousels();
    } else {
      document.addEventListener('DOMContentLoaded', initCarousels);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rovix-battery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function countUp(el) {
      var text = el.textContent;
      var match = text.match(/\d+/);
      if (!match) return;
      var target = parseInt(match[0], 10);
      var start = null;
      var duration = 1400;
      function frame(now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = text.replace(match[0], String(Math.round(target * eased)));
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function init(root) {
      var charts = (root || document).querySelectorAll('[data-rvx-battery-chart]:not(.is-armed)');
      if (!charts.length || reduce || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var chart = entry.target;
          observer.unobserve(chart);
          chart.classList.add('is-in');
          chart.querySelectorAll('[data-rvx-count]').forEach(function (value, i) {
            setTimeout(function () { countUp(value); }, 150 + i * 140);
          });
        });
      }, { threshold: 0.35 });
      charts.forEach(function (chart) {
        chart.classList.add('is-armed');
        observer.observe(chart);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rovix-product-info"] && !Shopify.designMode) return;
  try {
    
(function () {
function initRovix(root) {
/* Quantity stepper */
var qtyInput = root.querySelector('.rvx-qty-input');
var qtyMinus = root.querySelector('.rvx-qty-btn--minus');
var qtyPlus = root.querySelector('.rvx-qty-btn--plus');
if (qtyInput) {
function clampQty(val) {
var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
var maxAttr = qtyInput.getAttribute('max');
var max = maxAttr ? parseInt(maxAttr, 10) : null;
if (isNaN(val) || val < min) val = min;
if (max !== null && val > max) val = max;
return val;
}
function syncQty() {
if (qtyMinus) qtyMinus.classList.toggle('is-min', (parseInt(qtyInput.value, 10) || 1) <= (parseInt(qtyInput.getAttribute('min'), 10) || 1));
}
if (qtyMinus) qtyMinus.addEventListener('click', function () {
qtyInput.value = clampQty(parseInt(qtyInput.value, 10) - 1);
syncQty();
});
if (qtyPlus) qtyPlus.addEventListener('click', function () {
qtyInput.value = clampQty(parseInt(qtyInput.value, 10) + 1);
syncQty();
});
qtyInput.addEventListener('change', function () {
qtyInput.value = clampQty(parseInt(qtyInput.value, 10));
syncQty();
});
syncQty();
}
/* Hero slider: arrows, thumbnails, and active-state sync all operate on the real scroll-snap container */
var slider = root.querySelector('.rvx-hero-slider');
var thumbRow = root.querySelector('.rvx-thumb-row');
if (slider) {
/* slides and thumbs are read from the DOM each time, because the offer selector can reorder them (selected variant's image first) */
function getSlides() { return Array.prototype.slice.call(slider.querySelectorAll('.rvx-hero-slide')); }
function getThumbs() { return thumbRow ? Array.prototype.slice.call(thumbRow.querySelectorAll('.rvx-thumb')).filter(function (t) { return !t.classList.contains('rvx-thumb--ph'); }) : []; }
var prevBtn = root.querySelector('.rvx-hero-arrow--prev');
var nextBtn = root.querySelector('.rvx-hero-arrow--next');
function currentIndex() {
var scrollLeft = slider.scrollLeft;
var width = slider.clientWidth || 1;
return Math.round(scrollLeft / width);
}
function goTo(index) {
var count = getSlides().length;
if (!count) return;
var clamped = ((index % count) + count) % count;
slider.scrollTo({ left: clamped * slider.clientWidth, behavior: 'smooth' });
}
function setActiveThumb(index) {
getThumbs().forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
}
if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
if (thumbRow) thumbRow.addEventListener('click', function (e) {
var t = e.target && e.target.closest ? e.target.closest('.rvx-thumb') : null;
if (!t || t.classList.contains('rvx-thumb--ph')) return;
var i = getThumbs().indexOf(t);
if (i > -1) goTo(i);
});
var scrollDebounce;
slider.addEventListener('scroll', function () {
clearTimeout(scrollDebounce);
scrollDebounce = setTimeout(function () { setActiveThumb(currentIndex()); }, 80);
}, { passive: true });
}
/* static (marketing) bundle selector: a .rvx-bundles with NO data-rvx-option */
var staticBundles = root.querySelector('.rvx-bundles:not([data-rvx-option])');
if (staticBundles) {
var setInput = root.querySelector('.rvx-set-input');
staticBundles.addEventListener('click', function (e) {
var card = e.target && e.target.closest ? e.target.closest('.rvx-bundle-opt') : null;
if (!card || !staticBundles.contains(card)) return;
staticBundles.querySelectorAll('.rvx-bundle-opt').forEach(function (c) {
var on = c === card;
c.classList.toggle('is-selected', on);
c.setAttribute('aria-checked', on ? 'true' : 'false');
});
if (setInput) setInput.value = card.getAttribute('data-label') || '';
});
}
/* dynamic variant resolution across every real option (colour, set, ...) */
var dataEl = root.querySelector('.rvx-variant-data');
var pickers = root.querySelectorAll('[data-rvx-option]');
if (!dataEl || !pickers.length) return;
var variants;
try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
if (!variants || !variants.length) return;
var priceNow = root.querySelector('.rvx-price-now');
var priceWas = root.querySelector('.rvx-price-was');
var saveTag = root.querySelector('.rvx-save-tag');
var saveVal = root.querySelector('.rvx-save-val');
var idInput = root.querySelector('.rvx-id-input');
var cta = root.querySelector('button.rvx-cta[type="submit"]');
var ctaText = cta ? cta.querySelector('.rvx-cta-text') : null;
var mainImg = root.querySelector('.rvx-main-img');
/* current selection: seed from the pre-selected button in each picker */
var selection = {};
pickers.forEach(function (p) {
var opt = p.getAttribute('data-rvx-option');
var active = p.querySelector('[data-rvx-value].is-active, [data-rvx-value].is-selected');
if (!active) active = p.querySelector('[data-rvx-value]');
if (active) selection[opt] = active.getAttribute('data-rvx-value');
});
function matchVariant() {
for (var i = 0; i < variants.length; i++) {
var v = variants[i], ok = true;
for (var k in selection) { if (v.options[k] !== selection[k]) { ok = false; break; } }
if (ok) return v;
}
return null;
}
function apply(v) {
if (!v) return;
if (priceNow) priceNow.textContent = v.price;
if (idInput) idInput.value = v.id;
if (priceWas) { if (v.onSale) { priceWas.hidden = false; priceWas.textContent = v.compare; } else { priceWas.hidden = true; } }
if (saveTag) { if (v.onSale) { saveTag.hidden = false; if (saveVal) saveVal.textContent = v.savings; } else { saveTag.hidden = true; } }
if (cta) {
cta.disabled = !v.available;
if (ctaText) ctaText.textContent = v.available ? (cta.getAttribute('data-atc-label') || ctaText.textContent) : (cta.getAttribute('data-soldout-label') || ctaText.textContent);
}
if (mainImg && v.img) { mainImg.removeAttribute('srcset'); mainImg.setAttribute('src', v.img); }
if (v.url && window.history && window.history.replaceState) { try { window.history.replaceState({}, '', v.url); } catch (e) {} }
}
pickers.forEach(function (p) {
var opt = p.getAttribute('data-rvx-option');
p.addEventListener('click', function (e) {
var btn = e.target && e.target.closest ? e.target.closest('[data-rvx-value]') : null;
if (!btn || !p.contains(btn)) return;
selection[opt] = btn.getAttribute('data-rvx-value');
p.querySelectorAll('[data-rvx-value]').forEach(function (b) {
var on = b === btn;
if (b.classList.contains('rvx-swatch')) b.classList.toggle('is-active', on);
if (b.classList.contains('rvx-bundle-opt')) b.classList.toggle('is-selected', on);
b.setAttribute('aria-checked', on ? 'true' : 'false');
b.setAttribute('aria-pressed', on ? 'true' : 'false');
});
apply(matchVariant());
});
});
}
document.querySelectorAll('.rvx-pi').forEach(initRovix);
})();
/* Offer selector: radio cards -> variant id, live add-to-cart label, sticky bar, tracking events. */
(function () {
function initOffer(root) {
var offer = root.querySelector('[data-rvx-offer]');
if (!offer || offer.getAttribute('data-rvx-offer-ready')) return;
offer.setAttribute('data-rvx-offer-ready', '1');
var form = root.querySelector('form.rvx-form');
var inputs = Array.prototype.slice.call(offer.querySelectorAll('.rvx-offer-input'));
var idInput = root.querySelector('.rvx-id-input');
var cta = root.querySelector('button.rvx-cta[type="submit"]');
var ctaText = cta ? cta.querySelector('.rvx-cta-text') : null;
var nudge = offer.querySelector('[data-rvx-offer-nudge]');
var bar = root.querySelector('[data-rvx-offer-sticky]');
var barOpt = bar ? bar.querySelector('[data-rvx-sticky-opt]') : null;
var barPrice = bar ? bar.querySelector('[data-rvx-sticky-price]') : null;
var pickBtns = bar ? Array.prototype.slice.call(bar.querySelectorAll('[data-rvx-pick]')) : [];
/* The page H1 (only present when the offer selector drives the title); only its text is swapped, via textContent. */
var title = root.querySelector('h1[data-rvx-offer-title]');
/* Free gifts strip (block "offer_gifts"): every list and its total label are server-rendered with the shop money format;
   a selection change only shows the matching list and copies its pre-formatted total. Absent block = nothing happens. */
var gifts = root.querySelector('[data-rvx-gifts]');
var giftTotal = gifts ? gifts.querySelector('[data-rvx-gifts-total]') : null;
var giftLists = gifts ? Array.prototype.slice.call(gifts.querySelectorAll('[data-rvx-gifts-list]')) : [];
var boxLists = Array.prototype.slice.call(root.querySelectorAll('[data-rvx-box]'));
function setGifts(kind) {
if (!gifts || !giftLists.length) return;
var match = null;
giftLists.forEach(function (list) {
var on = list.getAttribute('data-rvx-gifts-list') === kind;
if (on) match = list;
list.classList.toggle('is-active', on);
list.setAttribute('aria-hidden', on ? 'false' : 'true');
});
gifts.querySelectorAll('[data-rvx-save-kind]').forEach(function (el) { el.hidden = el.getAttribute('data-rvx-save-kind') !== kind; });
var label = match ? (match.getAttribute('data-total-label') || '') : '';
if (giftTotal) { if (giftTotal.textContent !== label) giftTotal.textContent = label; giftTotal.hidden = !label; }
var changed = gifts.getAttribute('data-rvx-gifts-active') !== kind;
gifts.setAttribute('data-rvx-gifts-active', kind);
gifts.hidden = !match;
if (changed) {
try { gifts.dispatchEvent(new CustomEvent('rovix:gifts_update', { bubbles: true, detail: { offer: kind, total_label: label, count: match ? Number(match.getAttribute('data-count')) : 0 } })); } catch (e) {}
}
}
function checkedInput() {
for (var i = 0; i < inputs.length; i++) { if (inputs[i].checked) return inputs[i]; }
return inputs[0];
}
function payload(input) {
var d = input.dataset;
return {
variant_id: Number(d.variantId),
option_name: d.optionName,
option_value: d.optionValue,
offer: d.offer,
price: Number(d.priceCents) / 100,
price_formatted: d.price,
currency: d.currency,
quantity: 1
};
}
function emit(name, input) {
var detail = payload(input);
try { offer.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); } catch (e) {}
try {
if (window.dataLayer && typeof window.dataLayer.push === 'function') {
window.dataLayer.push({ event: name.replace(':', '_'), rovix_offer: detail });
}
} catch (e) {}
}
function apply(input) {
var d = input.dataset;
if (idInput) idInput.value = d.variantId;
if (ctaText && cta && !cta.disabled) ctaText.textContent = d.cta;
if (barOpt) barOpt.textContent = d.label;
if (barPrice) barPrice.textContent = d.price;
pickBtns.forEach(function (b) { var on = b.getAttribute('data-rvx-pick') === d.offer; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.classList.toggle('is-selected', on); });
if (nudge) nudge.hidden = d.offer === 'bogo';
root.querySelectorAll('[data-rvx-hide-single]').forEach(function (el) { el.hidden = d.offer === 'single'; });
document.querySelectorAll('[data-rvx-sticky-stock]').forEach(function (el) { el.hidden = d.offer !== 'bogo'; });
document.querySelectorAll('[data-rvx-sticky-extra]').forEach(function (el) { el.hidden = el.getAttribute('data-rvx-sticky-extra') !== d.offer; });
if (title && d.heading && title.textContent !== d.heading) title.textContent = d.heading;
if (giftLists.length) setGifts(d.offer);
if (!root.querySelector('.rvx-box-edit')) boxLists.forEach(function (b) { b.hidden = b.getAttribute('data-rvx-box') !== d.offer; });
showOfferImage(d.imageId, true);
}
/* Gallery follows the offer: the image assigned to the chosen variant (variant image in Shopify admin) opens first, and the images of the
   OTHER offers are taken out of the gallery (parked in the stash <template>). All other images keep their normal order, so nothing is
   shuffled. Slides and thumbs are rebuilt together. */
function showOfferImage(imageId) {
if (!imageId) return;
var slider = root.querySelector('.rvx-hero-slider');
if (!slider) return;
var thumbRow = root.querySelector('.rvx-thumb-row');
var stash = root.querySelector('#rvx-offer-gallery-stash');
var id = String(imageId);
function rebuild(container, selector) {
var items = Array.prototype.slice.call(container.querySelectorAll(selector));
var pool = items.slice();
if (stash) Array.prototype.forEach.call(stash.content.querySelectorAll(selector), function (el) { pool.push(el); });
var variantIds = {};
if (stash) Array.prototype.forEach.call(stash.content.querySelectorAll(selector), function (el) { variantIds[el.getAttribute('data-image-id')] = true; });
var byId = {};
pool.forEach(function (el) { var k = el.getAttribute('data-image-id'); if (!byId[k]) byId[k] = el; else if (container.contains(el)) byId[k] = el; });
var hit = byId[id];
if (!hit) return null;
if (!container.contains(hit)) hit = hit.cloneNode(true);
var rest = pool.filter(function (el) { return !variantIds[el.getAttribute('data-image-id')] && container.contains(el); });
rest = rest.filter(function (el, i) { return rest.indexOf(el) === i; });
rest.sort(function (a, b) { return Number(a.getAttribute('data-orig')) - Number(b.getAttribute('data-orig')); });
while (container.firstChild) container.removeChild(container.firstChild);
container.appendChild(hit);
rest.forEach(function (el) { container.appendChild(el); });
return hit;
}
var slide = rebuild(slider, '.rvx-hero-slide');
if (!slide) return;
var firstImg = slide.querySelector('img');
if (firstImg) { firstImg.loading = 'eager'; firstImg.setAttribute('fetchpriority', 'high'); }
if (thumbRow) {
var activeThumb = rebuild(thumbRow, '.rvx-thumb');
Array.prototype.forEach.call(thumbRow.querySelectorAll('.rvx-thumb'), function (x) { x.classList.toggle('is-active', x === activeThumb); });
thumbRow.scrollLeft = 0;
}
slider.scrollTo({ left: 0, behavior: 'auto' });
}
var galleryStartInput = inputs.filter(function (i) { return i.checked; })[0];
if (galleryStartInput) showOfferImage(galleryStartInput.dataset.imageId);
inputs.forEach(function (input) {
input.addEventListener('change', function () {
if (!input.checked) return;
apply(input);
emit('rovix:offer_select', input);
});
});
if (nudge) {
nudge.addEventListener('click', function () {
var target = null;
inputs.forEach(function (input) { if (input.getAttribute('data-offer') === 'bogo') target = input; });
if (!target || target.disabled) return;
target.checked = true;
apply(target);
emit('rovix:offer_select', target);
try { target.focus({ preventScroll: true }); } catch (e) {}
});
}
function unlockBundle() {
var target = null;
inputs.forEach(function (input) { if (input.getAttribute('data-offer') === 'bogo') target = input; });
if (!target || target.disabled) return;
target.checked = true;
apply(target);
emit('rovix:offer_select', target);
var first = root.querySelector('[data-rvx-gifts-list="bogo"] .rvx-og__item');
if (first) { first.classList.remove('is-unlocked'); void first.offsetWidth; first.classList.add('is-unlocked'); }
}
root.querySelectorAll('[data-rvx-unlock]').forEach(function (el) {
el.addEventListener('click', unlockBundle);
el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); unlockBundle(); } });
});
if (giftLists.length) { var startInput = checkedInput(); if (startInput) setGifts(startInput.getAttribute('data-offer')); }
var urgStart = checkedInput();
if (urgStart) root.querySelectorAll('[data-rvx-hide-single]').forEach(function (el) { el.hidden = urgStart.getAttribute('data-offer') === 'single'; });
if (urgStart) document.querySelectorAll('[data-rvx-sticky-stock]').forEach(function (el) { el.hidden = urgStart.getAttribute('data-offer') !== 'bogo'; });
if (urgStart) document.querySelectorAll('[data-rvx-sticky-extra]').forEach(function (el) { el.hidden = el.getAttribute('data-rvx-sticky-extra') !== urgStart.getAttribute('data-offer'); });
['bogo', 'single'].forEach(function (kind) {
  var sv = document.querySelector('[data-rvx-save-kind="' + kind + '"] .rvx-save__main');
  var mm = sv && sv.textContent.match(/[$€£]\s?[\d.,]+/);
  if (!mm) return;
  document.querySelectorAll('[data-rvx-sticky-extra="' + kind + '"] b').forEach(function (b) { b.textContent = 'Save ' + mm[0]; });
});
if (form) form.addEventListener('submit', function () { emit('rovix:offer_add', checkedInput()); });
/* Back/forward cache: the browser may restore the radio but not the hidden id. */
window.addEventListener('pageshow', function (e) { if (e.persisted) apply(checkedInput()); });
/* Sticky bar: moved to <body> (the panel is animated), shown once the main button has scrolled past, hidden at the footer. */
if (bar) {
var token = bar.getAttribute('data-rvx-sticky-for');
Array.prototype.slice.call(document.querySelectorAll('[data-rvx-sticky-for="' + token + '"]')).forEach(function (n) {
if (n !== bar && n.parentNode) n.parentNode.removeChild(n);
});
document.body.appendChild(bar);
var pickToggle = bar.querySelector('[data-rvx-sticky-toggle]');
var pickPanel = bar.querySelector('[data-rvx-sticky-pick]');
function setPickOpen(open) { if (!pickPanel || !pickToggle) return; pickPanel.hidden = !open; pickToggle.setAttribute('aria-expanded', open ? 'true' : 'false'); }
if (pickToggle && pickPanel) {
pickToggle.addEventListener('click', function (e) { e.preventDefault(); setPickOpen(pickPanel.hidden); });
pickPanel.addEventListener('click', function (e) {
var btn = e.target.closest ? e.target.closest('[data-rvx-pick]') : null;
if (!btn) return;
var kind = btn.getAttribute('data-rvx-pick');
var target = null;
inputs.forEach(function (input) { if (input.getAttribute('data-offer') === kind) target = input; });
if (!target || target.disabled) return;
target.checked = true;
apply(target);
emit('rovix:offer_select', target);
setPickOpen(false);
});
document.addEventListener('click', function (e) { if (!pickPanel.hidden && !bar.contains(e.target)) setPickOpen(false); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pickPanel.hidden) { setPickOpen(false); pickToggle.focus(); } });
}
if (cta) {
var bg = cta.style.getPropertyValue('--cta-bg');
var fg = cta.style.getPropertyValue('--cta-text');
if (bg) bar.style.setProperty('--rvx-offer-btn-bg', bg);
if (fg) bar.style.setProperty('--rvx-offer-btn-text', fg);
}
/* The bar shows from the first small scroll (so people can buy before they even reach the main button), hides while the main button is on screen, and returns once it is scrolled past. */
var ctaSeen = false, ctaAbove = false, footerShown = false;
var refresh = function () { var vis = !ctaSeen && (ctaAbove || window.scrollY > 120) && !footerShown; bar.classList.toggle('is-visible', vis); if (!vis) setPickOpen(false); };
if ('IntersectionObserver' in window && cta) {
new IntersectionObserver(function (entries) {
entries.forEach(function (en) { ctaSeen = en.isIntersecting; ctaAbove = !en.isIntersecting && en.boundingClientRect.top < 0; refresh(); });
}).observe(cta);
window.addEventListener('scroll', refresh, { passive: true });
var footer = document.querySelector('footer');
if (footer) {
new IntersectionObserver(function (entries) {
entries.forEach(function (en) { footerShown = en.isIntersecting; refresh(); });
}).observe(footer);
}
}
}
}
function initAll(scope) {
Array.prototype.slice.call((scope || document).querySelectorAll('.rvx-pi--offer')).forEach(initOffer);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
else initAll();
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
document.addEventListener('shopify:section:unload', function (e) {
var id = e.detail && e.detail.sectionId;
if (!id) return;
Array.prototype.slice.call(document.querySelectorAll('[data-rvx-sticky-for="' + id + '"]')).forEach(function (n) {
if (n.parentNode) n.parentNode.removeChild(n);
});
});
})();
(function () {
  function fitBar(bar) {
    var opt = bar.querySelector('[data-rvx-sticky-opt]');
    var row = bar.querySelector('.rvx-offer-sticky__pricerow');
    if (!opt) return;
    var info = opt.closest('.rvx-offer-sticky__info');
    bar.style.setProperty('--rvx-bar-fit', '1');
    var fit = 1;
    function overflows() {
      if (opt.scrollWidth > opt.clientWidth + 0.5) return true;
      if (row && info && row.getBoundingClientRect().width > info.clientWidth + 0.5) return true;
      return false;
    }
    while (overflows() && fit > 0.7) {
      fit = Math.round((fit - 0.03) * 100) / 100;
      bar.style.setProperty('--rvx-bar-fit', String(fit));
    }
  }
  function fitAll() { document.querySelectorAll('[data-rvx-offer-sticky]').forEach(fitBar); }
  function start() {
    fitAll();
    window.addEventListener('resize', fitAll);
    if ('MutationObserver' in window) {
      document.querySelectorAll('[data-rvx-offer-sticky]').forEach(function (bar) {
        var queued = false;
        new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fitBar(bar); }); }).observe(bar, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rovix-qty"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQty(root) {
      var addUrl = root.getAttribute('data-rvx-add-url') || '/cart/add';
      root.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-rvx-qty-add]') : null;
        if (!btn || btn.disabled) return;
        e.preventDefault();
        /* current variant: prefer the buy box's selected variant, else this section's default */
        var idInput = document.querySelector('.rvx-id-input');
        var vid = (idInput && idInput.value) ? idInput.value : root.getAttribute('data-rvx-default-id');
        if (!vid) { window.location = '#rvx-buybox'; return; }
        var qty = parseInt(btn.getAttribute('data-rvx-qty'), 10) || 1;
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…';
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] })
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (res.ok) { window.location = '/cart'; }
            else { btn.disabled = false; btn.textContent = label; }
          })
          .catch(function () { btn.disabled = false; btn.textContent = label; });
      });
    }
    document.querySelectorAll('.rvx-qty').forEach(initQty);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rovix-reviews-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      var tabs = root.querySelectorAll('.rvx-rev-tab');
      var sortSelect = root.querySelector('.rvx-rev-sort');
      var panel = root.querySelector('.rvx-rev-panel');
      var pagination = root.querySelector('.rvx-rev-pagination');
      var cardEls = Array.prototype.slice.call(root.querySelectorAll('.rvx-rev-card'));
      if (!cardEls.length) return;

      function norm(v) { return (v || '').trim().toLowerCase(); }

      var perPage = parseInt(panel && panel.getAttribute('data-per-page'), 10);
      if (!perPage || perPage < 1) perPage = 5;

      var state = { filter: '', sort: 'recent', page: 1 };

      function getFiltered() {
        var showAll = !state.filter || state.filter.indexOf('all') === 0;
        return cardEls.filter(function (card) {
          var cat = norm(card.getAttribute('data-category'));
          return showAll || !cat || cat === state.filter;
        });
      }

      function getSorted(list) {
        if (state.sort !== 'rating') return list;
        return list.slice().sort(function (a, b) {
          var sa = parseInt(a.getAttribute('data-stars'), 10) || 0;
          var sb = parseInt(b.getAttribute('data-stars'), 10) || 0;
          return sb - sa;
        });
      }

      function buildPagination(totalPages) {
        if (!pagination) return;
        pagination.innerHTML = '';
        if (totalPages <= 1) return;

        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'rvx-rev-page-btn';
        prev.textContent = '\u2039';
        prev.disabled = state.page <= 1;
        prev.setAttribute('data-page', state.page - 1);
        pagination.appendChild(prev);

        for (var i = 1; i <= totalPages; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rvx-rev-page-btn' + (i === state.page ? ' is-active' : '');
          btn.textContent = i;
          btn.setAttribute('data-page', i);
          pagination.appendChild(btn);
        }

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'rvx-rev-page-btn';
        next.textContent = '\u203a';
        next.disabled = state.page >= totalPages;
        next.setAttribute('data-page', state.page + 1);
        pagination.appendChild(next);
      }

      function render() {
        var list = getSorted(getFiltered());
        var totalPages = Math.max(1, Math.ceil(list.length / perPage));
        if (state.page > totalPages) state.page = totalPages;
        if (state.page < 1) state.page = 1;

        var start = (state.page - 1) * perPage;
        var visible = list.slice(start, start + perPage);

        cardEls.forEach(function (card) { card.hidden = true; });
        visible.forEach(function (card) { card.hidden = false; });

        buildPagination(totalPages);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          state.filter = norm(tab.getAttribute('data-filter'));
          state.page = 1;
          render();
        });
      });

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          state.sort = sortSelect.value;
          state.page = 1;
          render();
        });
      }

      if (pagination) {
        pagination.addEventListener('click', function (e) {
          var btn = e.target.closest ? e.target.closest('.rvx-rev-page-btn') : null;
          if (!btn || btn.disabled) return;
          var page = parseInt(btn.getAttribute('data-page'), 10);
          if (!page) return;
          state.page = page;
          render();
        });
      }

      render();
    }
    document.querySelectorAll('.rvx-reviews').forEach(initReviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rovix-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      var tabs = root.querySelectorAll('.rvx-rev-tab');
      var sortSelect = root.querySelector('.rvx-rev-sort');
      var panel = root.querySelector('.rvx-rev-panel');
      var pagination = root.querySelector('.rvx-rev-pagination');
      var cardEls = Array.prototype.slice.call(root.querySelectorAll('.rvx-rev-card'));
      if (!cardEls.length) return;

      function norm(v) { return (v || '').trim().toLowerCase(); }

      var perPage = parseInt(panel && panel.getAttribute('data-per-page'), 10);
      if (!perPage || perPage < 1) perPage = 5;

      var state = { filter: '', sort: 'recent', page: 1 };

      function getFiltered() {
        var showAll = !state.filter || state.filter.indexOf('all') === 0;
        return cardEls.filter(function (card) {
          var cat = norm(card.getAttribute('data-category'));
          return showAll || !cat || cat === state.filter;
        });
      }

      function getSorted(list) {
        if (state.sort !== 'rating') return list;
        return list.slice().sort(function (a, b) {
          var sa = parseInt(a.getAttribute('data-stars'), 10) || 0;
          var sb = parseInt(b.getAttribute('data-stars'), 10) || 0;
          return sb - sa;
        });
      }

      function buildPagination(totalPages) {
        if (!pagination) return;
        pagination.innerHTML = '';
        if (totalPages <= 1) return;

        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'rvx-rev-page-btn';
        prev.textContent = '\u2039';
        prev.disabled = state.page <= 1;
        prev.setAttribute('data-page', state.page - 1);
        pagination.appendChild(prev);

        for (var i = 1; i <= totalPages; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rvx-rev-page-btn' + (i === state.page ? ' is-active' : '');
          btn.textContent = i;
          btn.setAttribute('data-page', i);
          pagination.appendChild(btn);
        }

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'rvx-rev-page-btn';
        next.textContent = '\u203a';
        next.disabled = state.page >= totalPages;
        next.setAttribute('data-page', state.page + 1);
        pagination.appendChild(next);
      }

      function render() {
        var list = getSorted(getFiltered());
        var totalPages = Math.max(1, Math.ceil(list.length / perPage));
        if (state.page > totalPages) state.page = totalPages;
        if (state.page < 1) state.page = 1;

        var start = (state.page - 1) * perPage;
        var visible = list.slice(start, start + perPage);

        cardEls.forEach(function (card) { card.hidden = true; });
        visible.forEach(function (card) { card.hidden = false; });

        buildPagination(totalPages);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          state.filter = norm(tab.getAttribute('data-filter'));
          state.page = 1;
          render();
        });
      });

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          state.sort = sortSelect.value;
          state.page = 1;
          render();
        });
      }

      if (pagination) {
        pagination.addEventListener('click', function (e) {
          var btn = e.target.closest ? e.target.closest('.rvx-rev-page-btn') : null;
          if (!btn || btn.disabled) return;
          var page = parseInt(btn.getAttribute('data-page'), 10);
          if (!page) return;
          state.page = page;
          render();
        });
      }

      render();
    }
    function initAll(container) {
      (container || document).querySelectorAll('.rvx-reviews').forEach(initReviews);
    }
    initAll();
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rovix-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal() {
      var sections = document.querySelectorAll('.rvx-ugc:not(.is-in)');
      if (!sections.length) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        sections.forEach(function (s) { s.classList.add('is-in'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      sections.forEach(function (s) { io.observe(s); });
    }

    function autoplay(scope) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scope.querySelectorAll('.rvx-ugc__grid--carousel[data-rvx-autoplay]').forEach(function (el) {
        if (el.dataset.rvxReady) return;
        el.dataset.rvxReady = '1';
        if (reduce || el.children.length < 2) { el.removeAttribute('data-rvx-autoplay'); return; }
        var speed = parseFloat(el.dataset.rvxSpeed) || 45;
        var track = document.createElement('div');
        track.className = 'rvx-ugc__track';
        while (el.firstChild) track.appendChild(el.firstChild);
        el.appendChild(track);
        var origCount = track.children.length;
        var originals = Array.prototype.slice.call(track.children);
        function addClones() {
          originals.forEach(function (c) {
            var k = c.cloneNode(true);
            k.setAttribute('aria-hidden', 'true');
            k.removeAttribute('data-block-id');
            track.appendChild(k);
          });
        }
        addClones();
        var cards, offs, widths, loopW, cw;
        function measure() {
          cards = Array.prototype.slice.call(track.children);
          offs = cards.map(function (c) { return c.offsetLeft; });
          widths = cards.map(function (c) { return c.offsetWidth; });
          loopW = offs[origCount] - offs[0];
          cw = el.clientWidth;
        }
        measure();
        while (loopW + cw + widths[0] > track.scrollWidth && track.children.length < origCount * 6) { addClones(); measure(); }
        if ('ResizeObserver' in window) new ResizeObserver(measure).observe(el);
        window.addEventListener('resize', measure);
        var inView = true, pos = 0, last = null;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0 }).observe(el);
        }
        function frame(ts) {
          if (last === null) last = ts;
          var dt = Math.min((ts - last) / 1000, 0.1);
          last = ts;
          if (inView && !document.hidden && loopW > 0) {
            pos += speed * dt;
            if (pos >= loopW) pos -= loopW;
            var x = -pos;
            track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
            var mid = cw / 2;
            for (var i = 0; i < cards.length; i++) {
              var d = Math.abs(offs[i] + widths[i] / 2 + x - mid);
              var u = Math.min(1, d / (cw * 0.5));
              var e = u * u * (3 - 2 * u);
              cards[i].style.transform = 'scale(' + (1 - 0.08 * e).toFixed(3) + ')';
              cards[i].style.opacity = '1';
              cards[i].style.zIndex = String(100 - Math.round(e * 100));
            }
          }
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }
    function init() { reveal(); autoplay(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Re-scan when a section is (re)loaded in the theme editor.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
